export function earthJS(){
    (function($) {
        if ( location.protocol == 'file:' ) {
            alert( 'This demo does not work with the file protocol due to browser security restrictions.' );
        }


        var myearth;
        var sprites = [];

        window.addEventListener( 'load', function() {

            myearth = new Earth( 'myearth', {
            
                location: { lat: 35.8566, lng: 35.0 }, // Centro leggermente a est della Francia
            
                light: 'none',

                mapImage: '/wp-content/themes/understrap-child/dist/images/hologram-map.svg',
                transparent: true,
                
                autoRotate : true,
                autoRotateSpeed: 1.2,
                autoRotateDelay: 100,
                autoRotateStart: 2000,			
                
            } );
            
            
            myearth.addEventListener( "ready", function() {

                this.startAutoRotate();

                // add sprites
                
                // Aggiungere gli sprite in base alla posizione
                for (var i = 0; i < connections.length; i++) {
                    var location = { lat: connections[i][0], lng: connections[i][1], color: connections[i][2], size: connections[i][3] };
                    var spriteImage = getSpriteImageForLocation(location);
                    
                    sprites[i] = this.addSprite({
                        image: spriteImage,
                        scale: location.size || 0.01, // Imposta la scala predefinita a 0.01 se non è definita
                        offset: -0.5,
                        opacity: 0.5,
                        location: location
                    });
                    pulse(i);
                }
                
                
            } );
            
            
        } );

        function getSpriteImageForLocation(location) {
            // Funzione per ottenere l'immagine sprite in base alla location
            // Ad esempio, puoi fare un'associazione tra le location e le immagini sprite
            // e restituire l'immagine corretta in base alla location fornita.
            
            // Esempio:
            if (location.color === 'magenta') {
                return '/wp-content/themes/understrap-child/dist/images/dot_magenta.svg';
            } else {
                // Se non hai un'immagine specifica per la location, restituisci un'immagine predefinita
                return '/wp-content/themes/understrap-child/dist/images/dot_ottanio.svg';
            }
        }

        function getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min)) + min;
        }


        function pulse( index ) {
            var random_location = connections[getRandomInt(0, connections.length - 1)];
            var targetColor = random_location[2]; // Colore target per lo sprite
            var targetSize = random_location[3]; // Dimensione target per lo sprite
        
            // Verifica se il colore dello sprite è già corretto
            if (sprites[index].location.color !== targetColor) {
                // Se non è corretto, aggiorna il colore dello sprite
                sprites[index].location.color = targetColor;
                var spriteImage = getSpriteImageForLocation(sprites[index].location);
                sprites[index].image = spriteImage;
            }
        
            // Verifica se la dimensione dello sprite è già corretta
            if (sprites[index].location.size !== targetSize) {
                // Se non è corretto, aggiorna la dimensione dello sprite
                sprites[index].location.size = targetSize;
                sprites[index].scale = targetSize;
            }
        
            // Ritardo casuale prima di avviare l'animazione
            var randomDelay = getRandomInt(1500, 4600);
        
            setTimeout(function() {
                sprites[index].animate('scale', 0.4, {
                    duration: 590,
                    complete: function() {
                        sprites[index].animate('scale', 0.01, {
                            duration: 790,
                            complete: function() {
                                pulse(index);
                            }
                        });
                    }
                });
            }, randomDelay);
        }



        // locations of the sprites
        // connections[i][0]: Latitudine del punto
        // connections[i][1]: Longitudine del punto
        // connections[i][2]: Colore dello sprite
        // connections[i][3]: Dimensione dello sprite

        var connections = [
            [24.4539, 54.3773, '', 0.02], // Abu Dhabi
            [37.9838, 23.7275, 'magenta', 0.03], // Atene
            [41.9028, 12.4964, '', 0.02], // Roma
            [45.4642, 9.19, 'magenta', 0.02], // Milano
            [-33.4489, -70.6693, '', 0.02], // Buenos Aires
            [-33.918, 18.4232, 'magenta', 0.03], // Città del Capo
            [10.4806, -66.9036, '', 0.02], // Caracas
            [19.4326, -99.1332, 'magenta', 0.03], // Città del Messico
            [34.0522, -118.2437, '', 0.02], // Los Angeles
            [41.0082, 28.9784, 'magenta', 0.02], // Istanbul
            [38.7223, -9.1393, '', 0.02], // Lisbona
            [51.5074, -0.1278, 'magenta', 0.03], // Londra
            [46.0037, 8.9511, '', 0.02], // Lugano
            [40.4168, -3.7038, 'magenta', 0.03], // Madrid
            [25.7617, -80.1918, '', 0.02], // Miami
            [43.7384, 7.4246, 'magenta', 0.02], // Monaco
            [55.7558, 37.6176, '', 0.03], // Mosca
            [19.076, 72.8777, 'magenta', 0.02], // Mumbai
            [40.8518, 14.2681, '', 0.03], // Napoli
            [40.7128, -74.006, 'magenta', 0.02], // New York
            [48.8566, 2.3522, '', 0.02], // Parigi
            [8.9824, -79.5199, 'magenta', 0.03], // Panama
            [50.0755, 14.4378, '', 0.02], // Praga
            [-23.5505, -46.6333, 'magenta', 0.02], // San Paolo
        ];

    })(jQuery);
}
